import { render, staticRenderFns } from "./commonSelectInputBox.vue?vue&type=template&id=587d171e&scoped=true"
import script from "./commonSelectInputBox.vue?vue&type=script&lang=js"
export * from "./commonSelectInputBox.vue?vue&type=script&lang=js"
import style0 from "./commonSelectInputBox.vue?vue&type=style&index=0&id=587d171e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d171e",
  null
  
)

export default component.exports